
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(9(071|324|391)|1([35]45|889)|2086|2515|4896|5154|6803|7489|7875)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
